import { atomWithImmer } from 'jotai-immer';

import { DEFAULT_PAGINATION_STATE } from './constants.js';
import type { TablePaginationType } from './tablePaginationStore.types.js';

export const tablePaginationStore = atomWithImmer<TablePaginationType>({
  ...DEFAULT_PAGINATION_STATE,
});
